import Text from 'antd/es/typography/Text';
import { formatPhone } from '../../../../utils/Masks';
import { FaWhatsapp } from 'react-icons/fa';

interface IProps {
    phone: string;
    label?: boolean;
}

export default function PhoneSupport({ phone, label = false }: IProps) {

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Text style={{ margin: 0 }}>
                {label && <b>Telefone:</b>} {formatPhone(phone)}
            </Text>
            <a
                href={`https://wa.me/55${phone.replace(/\D/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#25D366', fontSize: 20 }}
            >
                <FaWhatsapp />
            </a>
        </div>
    )
}
